var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.81442 10.75C6.72002 10.6614 6.66699 10.5413 6.66699 10.416C6.66699 10.2908 6.72002 10.1707 6.81442 10.0821L11.6413 5.55432C11.7117 5.48848 11.8013 5.44366 11.8989 5.42552C11.9964 5.40738 12.0975 5.41674 12.1893 5.4524C12.2812 5.48806 12.3598 5.54844 12.4151 5.62592C12.4705 5.70341 12.5001 5.79452 12.5003 5.88779L12.5003 14.9433C12.5005 15.0369 12.4711 15.1284 12.4158 15.2062C12.3604 15.284 12.2817 15.3447 12.1896 15.3805C12.0975 15.4163 11.9961 15.4257 11.8983 15.4074C11.8005 15.3891 11.7107 15.344 11.6403 15.2777L6.81442 10.75Z",
    fill: "#5B5C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftChevron);
export default __webpack_public_path__ + "static/media/LeftChevron.d9d7def4f2441910b023d3bb7ad26f14.svg";
export { ForwardRef as ReactComponent };